<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/Welcome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>支付商编审核</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 卡片 -->
    <el-card class="box-card" style="margin-top:20px">
      <!-- 搜索  新增-->
      <el-row :gutter="24">
        <el-col :span="24">
          <el-form
            :inline="true"
            :model="searchForm"
            :rules="searchRules"
            ref="searchForRef"
            label-width="80px"
            autocomplete="on"
            size="mini"
          >
            <el-form-item label="名称" >
              <el-input v-model="searchForm.name" clearable type="text"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="success"  @click="searchSubmit()">搜索</el-button>
              <el-button type="primary" @click="addData">新增</el-button>
            </el-form-item>
          </el-form>

        </el-col>
      </el-row>

      <!-- 表格 -->
      <el-table
        ref="multipleTable"
        :data="tableLoadData"
        height="450"
        stripe
        border
      >
        <el-table-column :index="indexMethod" type="index" label="序号" width="50"></el-table-column>
        <el-table-column type="expand">
          <template slot-scope="props">
            <el-form label-position="left"  inline class="demo-table-expand">
              <el-table
                      :data="props.row.balance"

              >
                <el-table-column
                        prop="proxy_sn"
                        label="代理编码"
                        width="180">
                </el-table-column>
                <el-table-column
                        prop="name"
                        label="姓名"
                        width="180">
                </el-table-column>
                <el-table-column
                        prop="bank_name"
                        label="银行"
                        width="180">
                </el-table-column>
                <el-table-column
                        prop="bank_card"
                        label="卡号"
                        width="180">
                </el-table-column>
                <el-table-column
                        prop="rate"
                        label="比例(%)"
                        width="180">
                </el-table-column>
              </el-table>

            </el-form>
          </template>
        </el-table-column>

        <el-table-column
          label="商户编号"
          width="130"
          :show-overflow-tooltip='true'
          prop="cusid"
        >
        </el-table-column>
        <el-table-column
          label="所属通道"
          width="130"
          :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>{{ scope.row.source?scope.row.source.name:'' }}</span>
          </template>
        </el-table-column>
        <el-table-column
                label="所属代理"
                width="200"
                :show-overflow-tooltip='true'

        >
          <template slot-scope="scope">
            <span>{{ scope.row.member?scope.row.member.merchant_name:'' }}</span>
          </template>
        </el-table-column>
        <el-table-column
                label="平台分成(%)"
                width="100"
                :show-overflow-tooltip='true'

        >
          <template slot-scope="scope">
            <span>{{ scope.row.plat_rate }}</span>
          </template>
        </el-table-column>
        <el-table-column
                label="状态"
                width="100"
                :show-overflow-tooltip='true'

        >
          <template slot-scope="scope">
            <span style="color: #ff0000" v-if="scope.row.status==0">待审</span>
            <span style="color: #5daf34" v-if="scope.row.status==1">正常</span>
            <span style="color: #E6A23C" v-if="scope.row.status==2">拒绝</span>
          </template>
        </el-table-column>
        <el-table-column
                label="创建时间"
                width="100"
                :show-overflow-tooltip='true'

        >
          <template slot-scope="scope">
            <span>{{ scope.row.add_time }}</span>
          </template>
        </el-table-column>
        <el-table-column
                fixed="right"
                label="操作"
                width="180">
          <template slot-scope="scope">
            <el-dropdown  size="mini"  split-button  trigger="click">
              更多
              <el-dropdown-menu slot="dropdown" trigger="click">
                <el-dropdown-item @click.native="goAuth(scope.row)">审核</el-dropdown-item>
                <el-dropdown-item @click.native="goDetail(scope.row)">详情</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="block" style="margin-top:10px">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 30, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </el-card>
    <!-- 新增编辑弹框 -->
    <el-dialog :title="title" :visible.sync="dialogFormVisible" width="550px">
      <el-form :model="form" :rules="rules" ref="form" label-width="80px">

        <el-form-item label="名称" prop="name">
          <el-input v-model="form.name" autocomplete="off" placeholder="请输入名称"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="reset_dialogForm('form')">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')">确 定</el-button>
      </div>
    </el-dialog>


    <el-drawer
            title="支付商编审核"
            :visible.sync="drawer"
            :direction="direction"
            size="50%"
            :before-close="handleDrawerClose">

         <div style="width:90%;margin: 0 auto;">

          <el-form
              :inline="false"
              :model="dataForm"
              ref="dateFormRef"
              label-width="80px"
              autocomplete="on"
              size="mini"
              style="margin-top:20px"
      >
            <el-form-item label="分成详情" >
            <el-table
                    :data="balanceList"
                    style="width: 100%"
            >
              <el-table-column
                      prop="proxy_sn"
                      label="代理编码"
                      width="100">
              </el-table-column>
              <el-table-column
                      prop="name"
                      label="姓名"
                      width="100">
              </el-table-column>
              <el-table-column
                      prop="bank_name"
                      label="银行"
                      width="140">
              </el-table-column>
              <el-table-column
                      prop="bank_card"
                      label="卡号"
                      width="120">
              </el-table-column>
              <el-table-column
                      prop="rate"
                      label="比例(%)"
                      width="80">
              </el-table-column>
            </el-table>
           </el-form-item>
            <el-form-item label="商户编号" >
             <el-input v-model="dataForm.cusid" clearable type="text"></el-input>
            </el-form-item>
            <el-form-item label="所属通道" >
              <el-input v-model="dataForm.source_name" clearable type="text"></el-input>
            </el-form-item>
            <el-form-item label="通道比例" >
              <el-input v-model="dataForm.source_rate" clearable type="text"></el-input>
            </el-form-item>
<!--            <el-form-item label="银行名" >-->
<!--              <el-input v-model="dateForm.name" clearable type="text"></el-input>-->
<!--            </el-form-item>-->

            <el-form-item label="平台比例" >
              <el-input v-model="dataForm.plat_rate" clearable type="text">
                <i slot="suffix" style="color: #ff0000">%</i>
              </el-input>
            </el-form-item>
           <el-form-item>
          <el-button>取消</el-button>
          <el-button type="success">保存</el-button>

        </el-form-item>
      </el-form>
         </div>
    </el-drawer>

  </div>
</template>

<script>

  import moment from 'moment'     //日期时间转换
  export default {
    name: "posSourceParamsAuthList",
    components: {

    },
    props: {},
    data() {
      return {
        balanceList:[],

        dataForm:{
          name:'',
          cusid:'',
          source_name:'',
          plat_rate:0,
          source_rate:0
        },
        drawer:false,
        direction: 'rtl',
        // 搜索
        searchForm: {
          name: "",
        },
        searchRules: {
          name: [
            { required: true, message: "请输入名称", trigger: "blur" }
          ],
        },
        // 数据
        tableLoadData: [],
        pageNum:1,// 当前页码
        pageSize:10,// 每页大小
        total:0,//总条目数

        showType: '',

        roleList: [],

        rules: {
          name: [
            { required: true, message: '请输入名称', trigger: 'blur' },
            {
              min: 1,
              max: 15,
              message: "长度在 1 到 15 个字符",
              trigger: "blur",
            }
          ],
        },
        dialogFormVisible: false,
        title: '',
        form: {
          name: '',
        },

      };
    },
    created() {
      this.showType = this.$route.query.showType;
      this.DataList()
    },
    mounted() {
    },
    filters: {
      //时间格式化
      dateFormat(add_time) {
        if (add_time == undefined) {
          return "";
        }
        return moment(add_time*1000).format("YYYY-MM-DD HH:mm:ss");
      },
    },
    methods: {
      handleDrawerClose(){
        this.drawer=false;
      },
      goDetail(){

      },
      goAuth(row){
        this.dataForm.cusid=row.cusid;
        this.dataForm.source_name=row.source.name;
        this.balanceList=[];
        this.balanceList=row.balance;
        this.drawer=true;
      },
      indexMethod(index) {
        return (this.pageNum - 1) * this.pageSize + index + 1
      },
      DataList(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          showType: this.showType,
          pageNum: this.pageNum,
          pageSize: this.pageSize,
        }
        this.$axios.findPaySourceParamsBalanceListP(param).then(res=>{
          if(res.code == 200){
            this.tableLoadData = res.data.data
            this.total = res.data.total
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      // 设置每页条数
      handleSizeChange(newSize) {
        this.pageSize = newSize
        this.DataList()
      },
      // 分页跳转
      handleCurrentChange(newPage) {
        this.pageNum = newPage
        this.DataList()
      },
      departData(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
        }
        this.$axios.findTree(param).then(res=>{
          if(res.code == 200){
            this.rightslist = res.data.data
          }
        }).catch(error=>{
          console.log(error);
        })
      },

      // 新增
      addData() {
        this.$router.push('/payMerForm')
      },
      handelEdit(index) {
        this.id = index.data.row.id
        this.title = '编辑'
        this.form = {
          name: this.name,
        }
        this.dialogFormVisible = true
        // this.form = {...row};
        // 或者
        this.form = JSON.parse(JSON.stringify(index.data.row))
      },

      reset_dialogForm(formName) {
        this.dialogFormVisible = false
        this.$nextTick(() => {
          this.$refs[formName].resetFields()
        })
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if(!this.id){
              const param = {
                name: this.form.name,
                operator_id: sessionStorage.getItem('user_id'),
                company_id: sessionStorage.getItem('company_id'),
                access_token: sessionStorage.getItem('token'),
              }
              this.$axios.insuranceCorpSave(param).then(res =>{
                console.log(res,7777);
                if(res.code == 200){
                  this.DataList()
                  this.$message.success(res.msg)
                  this.dialogFormVisible = false
                }else{
                  this.$message.error(res.msg);
                }
              })
            }else{
              const param = {
                id: this.form.id,
                name: this.form.name,
                operator_id: sessionStorage.getItem('user_id'),
                company_id:sessionStorage.getItem('company_id'),
                access_token:sessionStorage.getItem('token'),
              }
              this.$axios.insuranceCorpSave(param).then(res =>{
                if(res.code == 200){
                  this.$message.success(res.msg)
                  this.DataList()
                  this.dialogFormVisible = false
                }else{
                  this.$message.error(res.msg);
                }
              })
            }

          }
        })
      },
      // searchSubmit() {
      //   const param = {
      //       queryParams: this.searchForm.name,
      //       company_id:sessionStorage.getItem('company_id'),
      //       access_token:sessionStorage.getItem('token'),
      //       page: this.pageNum,
      //       pageSize: this.pageSize
      //   }
      //   this.$refs.searchForRef.validate((valid) => {
      //     if (valid) {
      //       this.$axios.insuranceCorpList(param).then(res=>{
      //         if(res.code == 200){
      //           this.tableLoadData = res.data.data
      //           this.total = res.data.total
      //         }
      //       })
      //     }
      //   })
      // },

      handelDel(e) {
        console.log(e);
        this.$confirm('此操作将删除该分类, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const param = {
            operator_id: sessionStorage.getItem('user_id'),
            company_id:sessionStorage.getItem('company_id'),
            access_token:sessionStorage.getItem('token'),
            id: e.data.row.id,
          }
          this.$axios.insuranceCorpDel(param).then(res=>{
            if(res.code == 200){
              this.$message.success(res.msg);
              this.DataList()
            }else{
              this.$message.error(res.msg);
            }
          }).catch(error=>{
            console.log(error);
          })
        }).catch(() => {
          // 点击取消:不删除了
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
          this.DataList()
        });
        this.teamDialog = false
      },


    },
  };
</script>
<style>

</style>
